import api from './api';

// Original OTP-based login/register method (renamed to registerWithOtp for clarity)
export async function registerWithOtp(data: object) {
  const response = await api.post('/auth/register', data).catch((err) => {
    return { status: err.response.status, data: err.response.data };
  });
  return { status: response.status, data: response.data };
}

// New email/password login method
export async function login(email: string, password: string) {
  const response = await api.post('/auth/login', { email, password }).catch((err) => {
    return { 
      status: err.response?.status ?? 500, 
      data: err.response?.data ?? 'Network Error' 
    };
  });
  return { status: response.status, data: response.data };
}

// New request password reset method
export async function requestPasswordReset(email: string) {
  const response = await api.post('/auth/request-password-reset', { email }).catch((err) => {
    return { 
      status: err.response?.status ?? 500, 
      data: err.response?.data ?? 'Network Error' 
    };
  });
  return { status: response.status, data: response.data };
}

// New reset password method using token from email
export async function resetPassword(token: string, newPassword: string) {
  const response = await api.post('/auth/reset-password', { 
    token, 
    password: newPassword 
  }).catch((err) => {
    return { 
      status: err.response?.status ?? 500, 
      data: err.response?.data ?? 'Network Error' 
    };
  });
  return { status: response.status, data: response.data };
}

export async function logout() {
  const response = await api.post('/auth/logout', {}).catch((err) => {
    console.error('logout', err);
    return {
      status: err.response?.status ?? 500,
      data: err.response.data ?? 'Network Error',
    };
  });
  return { status: response.status, data: response.data };
}

export async function update(payload: object) {
  const response = await api.post('/auth/update', payload).catch((err) => {
    console.error('update', err);
    return {
      status: err.response?.status ?? 500,
      data: err.response.data ?? 'Network Error',
    };
  });
  return { status: response.status, data: response.data };
}

export async function me() {
  const response = await api.get('/auth/me').catch((err) => {
    console.error('me', err);
    return {
      status: err.response?.status ?? 500,
      data: err.response?.data ?? 'Network Error',
    };
  });
  return { status: response.status, data: response.data };
}